// @flow

import removeEstimateGroup from '../../../Services/removeEstimateGroup';
import type { RemoveEstimateGroupParams } from '../../../types';

export default (params: RemoveEstimateGroupParams) => async (dispatch: Function) => dispatch(removeEstimateGroup(params))